import React, { lazy } from 'react'
import MapPageLazyLoadWrapper from 'map/MapPageLazyLoadWrapper/MapPageLazyLoadWrapper'

const MapPage = lazy(() => {
  return import('./mapPage')
})

const SiteProposalMapPageWrapper = () => {
  return <MapPageLazyLoadWrapper><MapPage /></MapPageLazyLoadWrapper>
}

export default SiteProposalMapPageWrapper
